import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../context/breadcrumb.context'
import { IconList } from '../icon/icon'
import { useParamsInt } from '../hooks/location'
import { Card } from '../card/card'
import { useLoad } from '../hooks/load'
import { useNotificationContext } from '../../context/notification/context'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { FormNew } from '../form-new/form'
import { FormNewTextConfirm } from '../form-new/form-text-confirm'
import { FormNewButtonSubmitBack } from '../form-new/form-button'
import { recycleErrorMessage } from '../error/server-message'
import { withReference } from '../error/error-notice'

export const RecycleDelete = ({ useApiForm, field1, parentURL }) => {
  const apiForm = useApiForm()
  const history = useHistory()
  const { id } = useParamsInt()

  const notificationContext = useNotificationContext()

  useLoad(() => apiForm.get(`${id}/deleted`), [id])

  const value1 = useMemo(() => apiForm.form[field1], [apiForm, field1])

  const handleSubmit = async () => {
    try {
      await apiForm.delete(`${id}/purge`)
      notificationContext.toast.notify('purge success', 3000)
      history.replace(parentURL)
    } catch (err) {
      // Nothing on this confirm page is retryable (a 404 means it's already
      // gone; anything else still leaves no state worth resubmitting), so
      // say what happened via toast -- it outlives the navigation -- and go
      // back to the list the same way a success does.
      notificationContext.toast.notify(withReference(recycleErrorMessage(err, 'That item was already permanently deleted.'), err), 5000)
      history.replace(parentURL)
    }
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="permanently delete">
        <Card title='permanently delete'>

          <div className='alert alert-warning my-2'>You are about to permanently delete {value1}</div>

          <FormNew enabled onSubmit={handleSubmit}>
            <FormNewTextConfirm name='confirm' confirmValue='delete' autoFocus />
            <FormNewButtonSubmitBack submitText='Permanently Delete' backUrl={parentURL} />
          </FormNew>
        </Card>
      </BreadcrumbView>
    </React.Fragment>
  )
}
